import axios, { AxiosInstance } from 'axios';
import { endpoint } from '@/api/apiConstants';
import router from '@/router';
import store from '@/store';

const API_BASE_URL = process.env.VUE_APP_API_ENDPOINT;

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});
const axiosInstanceUseRefreshToken: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

const axiosRefreshToken = (originalRequest?: any, finallCallback?: () => void) => {
  return new Promise((resolve, reject) => {
    axiosInstanceUseRefreshToken
      .post(
        endpoint.refreshToken,
        {},
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('refreshToken') },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          const accessToken = res.data.accessToken;
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', res.data.refreshToken);
          processQueue(null);

          // Update the access token for current requests after refresh token succeed. 
          if (accessToken && originalRequest && originalRequest.headers && originalRequest.headers.Authorization) {
            originalRequest.headers = {
              ...originalRequest.headers,
              'Authorization': 'Bearer ' + res.data.accessToken,
              'Access-Control-Expose-Headers': 'Access-Control-Allow-Origin, Access-Control-Allow-Credentials, Content-Disposition'
            };
          }
          if (originalRequest) {
            resolve(axiosInstance(originalRequest));
          } else {
            resolve(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        processQueue(error);
        store.dispatch('toasts/appendTimeToast', { label: 'ログインセッションが切れました' });
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');

        const loginPageName = 'a10';
        if (router.currentRoute.value.name && router.currentRoute.value.name !== loginPageName) {
          // アクセスしようとした認証必須ページをstoreに保存し、ログインページに遷移させる
          store.commit('router/setLoginTransitionData', router.currentRoute.value);
          router.push({ name: loginPageName });
        }
        if (originalRequest) {
          reject(error);
        } else {
          reject(false);
        }
      })
      .then(() => {
        if (typeof finallCallback === 'function') {
          finallCallback();
        }
      });
    });
};

axiosInstance.interceptors.request.use(async (config) => {

 if (config.url !== process.env.UNDER_MAINTENANCE_URL_ENDPOINT) {
   try {
      // メンテナンス状態をチェック
      const res = await axios.get(process.env.UNDER_MAINTENANCE_URL_ENDPOINT);
      if (res.data !== 0) {
        // メンテナンス画面にリダイレクト
        router.isReady().then(() => {
          if (router.currentRoute.value.name !== '503') {
            router.push({ name: '503' });
          }
        });
      }
    } catch (error) {
        console.error('メンテナンス情報の取得に失敗しました:', error);
    }
  }

  config.headers = {
    ...config.headers,
    Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    'Content-Type': 'application/json',
    //'X-AUTHORIZATION-TOKEN': 'Bearer ' + localStorage.getItem('accessToken'),
  };
  return config;
});

type QueueItem = {
  resolve: (value?: string | PromiseLike<string> | undefined) => void;
  reject: (reason?: Error) => void;
};
let failedQueue: QueueItem[] = [];
let isRefreshing = false;

const processQueue = (error: Error | null) => {
  failedQueue.forEach((quene) => {
    if (error) {
      quene.reject(error);
    } else {
      quene.resolve();
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    const errorStatus: number = error.response.status;
    if (errorStatus === 401 && !originalRequest._retry) {
      console.error('unauthorized');
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => {
            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }
      originalRequest._retry = true;
      isRefreshing = true;
      return axiosRefreshToken(originalRequest, () => {
        isRefreshing = false;
      });
    }
    if ([401, 500, 503].includes(errorStatus)) {
      // 401 認証エラー
      // 500 DBエラー
      // 503 メンテナンス
      store.commit('error/setErrorState', errorStatus);
      router.push({ name: 'xx999' });
    }

    // それ以外
    // 400 リクエストエラー
    return Promise.reject(error);
  }
);

export default axiosInstance;
export { axiosInstanceUseRefreshToken as noAuthAxios, axiosRefreshToken };
